import { Suspense, type FunctionComponent } from 'react';

// oxlint-disable-next-line no-restricted-imports
import type { LogoProps } from '@atlaskit/logo';
import {
  ChunkLoadErrorBoundary,
  ErrorBoundary,
} from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

export const LazyJiraIcon: FunctionComponent<LogoProps> = (props) => {
  const JiraIcon = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "atlaskit-logo-jira" */ '@atlaskit/logo/jira/icon'
      ),
    { namedImport: 'JiraIcon' },
  );

  return (
    <ErrorBoundary tags={{ ownershipArea: 'trello-web-eng' }}>
      <ChunkLoadErrorBoundary fallback={null}>
        <Suspense fallback={null}>
          <JiraIcon {...props} />
        </Suspense>
      </ChunkLoadErrorBoundary>
    </ErrorBoundary>
  );
};
